import React from "react";
import {
	Box,
	Container,
	Typography,
	Grid,
	IconButton,
	List,
	MenuItem,
	ListItemButton,
	ListItemIcon,
	ListItemText,
	colors,
	useTheme,
	useMediaQuery
} from "@mui/material";
import { ArrowBack, Email, FactCheck, ListAlt, ReceiptLong, CardGiftcard } from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import { Outlet } from "react-router-dom";
import { AdminDashboardContainer } from "./styles";

const Admin = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const theme = useTheme();
	const isSmallerScreen = useMediaQuery(theme.breakpoints.down("md"));
	const isOverviewSelected = location.pathname.includes("/overview");
	const isInvitationSelected = location.pathname.includes("/invitations");
	const isOrdersSelected = location.pathname.includes("/orders");
	const isTransactionsSelected = location.pathname.includes("/transactions");
	const isAffiliateSelected = location.pathname.includes("/affiliate");

	const handleGoBack = () => {
		navigate("/");
	};

	return (
		<Container maxWidth={"xl"}>
			<AdminDashboardContainer mt={7} height={"94vh"} p={1}>
				<Box display={"flex"} alignItems={"center"} my={2}>
					<Box className={"back-btn"} onClick={handleGoBack}>
						<IconButton>
							<ArrowBack width={20} />
						</IconButton>
						<Typography>Dashboard</Typography>
					</Box>
				</Box>
				<Grid container spacing={4} alignItems={"flex-start"}>
					<Grid size={isSmallerScreen ? 12 : 3} className={"menu-tabs"}>
						<List>
							<MenuItem selected={isOverviewSelected}>
								<ListItemButton onClick={() => navigate("/admin/overview")}>
									<ListItemIcon style={isSmallerScreen ? { display: "flex", justifyContent: "center" } : {}}>
										<FactCheck />
									</ListItemIcon>
									{!isSmallerScreen && <ListItemText primary="Overview" />}
								</ListItemButton>
							</MenuItem>
							<MenuItem selected={isInvitationSelected}>
								<ListItemButton onClick={() => navigate("/admin/invitations")}>
									<ListItemIcon style={isSmallerScreen ? { display: "flex", justifyContent: "center" } : {}}>
										<Email />
									</ListItemIcon>
									{!isSmallerScreen && <ListItemText primary="Invitations" />}
								</ListItemButton>
							</MenuItem>
							<MenuItem selected={isOrdersSelected}>
								<ListItemButton onClick={() => navigate("/admin/orders")}>
									<ListItemIcon style={isSmallerScreen ? { display: "flex", justifyContent: "center" } : {}}>
										<ListAlt />
									</ListItemIcon>
									{!isSmallerScreen && <ListItemText primary="Orders" />}
								</ListItemButton>
							</MenuItem>
							<MenuItem selected={isTransactionsSelected}>
								<ListItemButton onClick={() => navigate("/admin/transactions")}>
									<ListItemIcon style={isSmallerScreen ? { display: "flex", justifyContent: "center" } : {}}>
										<ReceiptLong />
									</ListItemIcon>
									{!isSmallerScreen && <ListItemText primary="Transactions" />}
								</ListItemButton>
							</MenuItem>
							<MenuItem selected={isAffiliateSelected}>
								<ListItemButton onClick={() => navigate("/admin/affiliate")}>
									<ListItemIcon style={isSmallerScreen ? { display: "flex", justifyContent: "center" } : {}}>
										<CardGiftcard />
									</ListItemIcon>
									{!isSmallerScreen && <ListItemText primary="Affiliate" />}
								</ListItemButton>
							</MenuItem>
						</List>
					</Grid>
					<Grid size={isSmallerScreen ? 12 : 9} style={{ backgroundColor: colors.grey[100], padding: 15 }}>
						<Outlet />
					</Grid>
				</Grid>
			</AdminDashboardContainer>
		</Container>
	);
};

export default Admin;
